@if (form) {
<form lin-layout-form [formGroup]="form" (ngSubmit)="replaceDevice()">
  <div fxLayout="column">
    <div fxLayoutAlign="flex-start center">
      <lin-form-label required class="label">{{ 'FIELDS.imeiOld' | translate }}:</lin-form-label>
      <mat-form-field class="form-field" [errorState]="">
        <input matInput formControlName="imeiOld" data-testid="input-imei-old" />
        <mat-error><lin-form-field-error [control]="form.get('imeiOld')" controlName="imeiOld"></lin-form-field-error></mat-error>
      </mat-form-field>
    </div>

    <div class="info">
      <span>
        {{ 'ADMIN.DEVICES.VEHICLE' | translate }}: @if (oldDevice?.deviceInstallation) { {{ 'ADMIN.DEVICES.REPLACEMENT.INSTALLED_IN' |
        translate: { regNo: oldDevice.deviceInstallation.vehicle.regNo } }} } @if (!oldDevice?.deviceInstallation && oldDeviceLastVehicle) {
        {{ 'ADMIN.DEVICES.REPLACEMENT.WAS_INSTALLED_IN' | translate: { regNo: oldDeviceLastVehicle.vehicleRegNo } }} } @if
        (!oldDevice?.deviceInstallation && !oldDeviceLastVehicle) { - }
      </span>
      <span>{{ 'ADMIN.DEVICES.ON_CONTRACT_TILL' | translate }}: {{ (oldDevice?.contractFinishAt | dayjsDate) || '-' }}</span>

      @if (oldDevice && !oldDeviceIsOffline) {
      <span class="lin-form-error">{{ 'ADMIN.DEVICES.REPLACEMENT.OLD_DEVICE_NOT_OFFLINE' | translate }}</span>
      } @if (oldDevice && !this.oldDevice.deviceInstallation && !oldDeviceInStock) {
      <span class="lin-form-error">{{ 'ADMIN.DEVICES.REPLACEMENT.OLD_DEVICE_IS_UNINSTALLED_AND_NOT_IN_STOCK' | translate }}</span>
      }
    </div>
  </div>

  <div fxLayout="column">
    <div fxLayoutAlign="flex-start center">
      <lin-form-label required class="label">{{ 'FIELDS.imeiNew' | translate }}:</lin-form-label>
      <mat-form-field class="form-field">
        <input matInput formControlName="imeiNew" data-testid="input-imei-new" />
        <mat-error><lin-form-field-error [control]="form.get('imeiNew')" controlName="imeiNew"></lin-form-field-error></mat-error>
      </mat-form-field>
    </div>

    <div class="info">
      @if (bothDevicesFilled && oldDevice.deviceInstallation && !newDeviceInStock) {
      <span class="lin-form-error">{{ 'ADMIN.DEVICES.REPLACEMENT.NEW_DEVICE_IS_NOT_IN_STOCK' | translate }}</span>
      } @if (bothDevicesFilled && !oldDevice.deviceInstallation && !newDeviceIsInstalledInOldDeviceVehicle) {
      <span class="lin-form-error">{{ 'ADMIN.DEVICES.REPLACEMENT.NEW_DEVICE_WRONG_INSTALLED' | translate }}</span>
      }
    </div>
  </div>

  <lin-form-label required>{{ 'FIELDS.reason' | translate }}: </lin-form-label>
  <mat-form-field>
    <textarea class="textarea" matInput rows="2" formControlName="reason"></textarea>
    <mat-error>
      <lin-form-field-error [control]="form.get('reason')" controlName="reason"></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <lin-form-submit-button
    fxLayoutAlign="center"
    [isDisabled]="!devicesAreValid"
    [isLoading]="isSubmitting"
    data-testid="btn-dialog-confirm"
  >
    {{ 'ADMIN.DEVICES.REPLACEMENT.ADD_REPLACEMENT' | translate }}
  </lin-form-submit-button>
</form>
}
